import styles from "../../../_common/CrudFormStyles.module.scss";
import { Form, Input, Row, Col, Badge, message } from "antd";
import { translateKey as t } from "../../../../../locales/translation";
import { faDatabase, faGlobe, faIdCard, faTag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PartnersController } from "../../PartnersController";
import { observer } from "mobx-react";

const PartnerForm = observer(({ controller }: { controller: PartnersController }) => {
  const [form] = Form.useForm();
  controller.setFormRef(form);

  const { partner, isReadOnly, formMode, formFieldsSize, showFieldsIcon } = controller;

  const handleInputChange = (e: any) => {
    const value: string = e.target.value;
    const key: string = e.target.name;

    if ((key === "clientRef" || key === "dbName") && !RegExp("^[a-zA-Z0-9_.()&-]*$").test(value)) {
      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
      message.warning({
        content: t(
          "lblFieldMustNotContainSpecialCharactersOrSpaces",
          "Field must not contain special characters or spaces"
        ),
        key,
        duration: 4,
      });
      return;
    }

    controller.setPartner(value, key);
  };

  return (
    <Form
      form={form}
      className={styles.form}
      requiredMark={false}
      initialValues={{
        clientRef: partner.clientRef,
        name: partner.name,
        dbName: partner.dbName,
      }}
      layout="vertical"
    >
      <Row className={styles.newRow} gutter={20} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!partner.clientRef}>
                <span className={styles.formTitle}>{t("lblClientRef", "Client Ref")}</span>
              </Badge>
            }
            name="clientRef"
            rules={[
              { required: true, whitespace: true, message: t("lblClientRefIsRequired", "Client Ref is required") },
            ]}
          >
            <Input
              name="clientRef"
              onChange={handleInputChange}
              disabled={isReadOnly || formMode === "edit"}
              autoFocus={formMode === "create"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faTag} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!partner.name}>
                <span className={styles.formTitle}>{t("lblName", "Name")}</span>
              </Badge>
            }
            name="name"
            rules={[{ required: true, whitespace: true, message: t("lblNameIsRequired", "Name is required") }]}
          >
            <Input
              name="name"
              onChange={handleInputChange}
              disabled={isReadOnly}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faIdCard} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={24}>
          <Form.Item
            colon={false}
            label={<span className={styles.formTitle}>{t("lblDBName", "DB Name")}</span>}
            name="dbName"
          >
            <Input
              name="dbName"
              onChange={handleInputChange}
              disabled={isReadOnly}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faDatabase} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* PRO-84: read-only view of the OpenFleet stack serving this partner (reported by the API, never edited here). */}
      {formMode === "edit" && (
        <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
          <Col span={24}>
            <Form.Item colon={false} label={<span className={styles.formTitle}>{t("lblEnvironment", "Environment")}</span>}>
              <Input
                value={partner?.environment?.providerUrl || ""}
                placeholder={t("lblUnknownEnvironment", "Unknown environment")}
                disabled
                readOnly
                prefix={showFieldsIcon && <FontAwesomeIcon icon={faGlobe} style={{ color: "rgba(0,0,0,.25)" }} />}
                size={formFieldsSize}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  );
});

export { PartnerForm };
